import { ModalHeader, Spinner } from '@ds';
import { useHubResources } from '@lp/features/RoutePlanner/hooks/useHubResources';
import { ZonedDateTime } from '@internationalized/date';
import { RoutePlannerClinicalSpecialistList } from './ClinicalSpecialistListTable/ClinicalSpecialistList';
import { CaseClinicalSpecialistResource, CaseResource, OrganType } from '@/api/apis/case';
import { CSAssignmentCandidate } from '@/api/apis/resources';

export type RemoveClinicalSpecialistModalContentProps = {
  organType: OrganType;
  resource: CaseResource<CaseClinicalSpecialistResource>;
  selectedResourceId?: string;
  onAction?: (data: CSAssignmentCandidate, cb: () => void, goTime?: ZonedDateTime) => void;
  isSwap?: boolean;
};

export const RemoveClinicalSpecialistModalContent = ({
  organType,
  resource,
  selectedResourceId,
  onAction,
  isSwap,
}: RemoveClinicalSpecialistModalContentProps) => {
  const { getClinicalSpecialists, isLoading } = useHubResources({ enabled: true });
  const selectedCS = getClinicalSpecialists(resource.data!.baseLocation!).find(
    (cs) => cs.employeeId === resource.data?.id,
  );
  const selectedHubId = selectedCS?.shiftHubId || resource?.data?.baseLocation?.id;

  return resource && !isLoading ? (
    <>
      <ModalHeader className="!text-l text-[24px]! p-0 m-0 text-base-5">Select resource to swap to</ModalHeader>
      <RoutePlannerClinicalSpecialistList
        organType={organType}
        selectedHubId={selectedHubId}
        selectedResourceId={selectedResourceId}
        onAction={onAction}
        isSwap={isSwap}
      />
    </>
  ) : (
    <Spinner />
  );
};
